import React from "react";

import { Grid, CircularProgress } from "@mui/material";
import "./walletaction.css";

import CustomModal from "../../Components/Modal/CustomModal";

import { CiWallet } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TbRefreshDot } from "react-icons/tb";
import { IoMdSpeedometer } from "react-icons/io";
import GradiantButton from "../Button/GradiantButton";
import { REACT_APP_TRANSACTION_HASHLINK } from "../../Config/Config"

const Walletaction = ({
  WalletActionModal,
  Loader1,
  Loader2,
  Loader3,
  hash,
  handleClose,
  isCompleted,
}) => {
  return (
    <div>
      <CustomModal
        open={WalletActionModal}
        closebtn={"remove"}
        modalTitle={<h5>Wallet Actions</h5>}
        width={{lg: '30%', md: '30%', sm: '90%', xs: '90%'}}
        modalContent={
          <Grid
            container
            lg={12}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="p-2 rounded"
              bgcolor={"rgba(0, 0, 0, 0.32)"}
            >
              <Grid className="d-flex">
                <p>
                  {" "}
                  <CiWallet className="text-light mx-2" size={30} /> Request Sent
                </p>
              </Grid>

              {Loader1 ? (
                <span>
                  <CircularProgress
                    fourColor
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </span>
              ) : (
                <p>
                  {" "}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </p>
              )}
            </Grid>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="p-2 rounded mt-2"
              bgcolor={"rgba(0, 0, 0, 0.32)"}
            >
              <Grid className="d-flex">
                <p>
                  {" "}
                  <TbRefreshDot className="text-light mx-2" size={30} />
                  Transaction Underway
                </p>
              </Grid>

              {Loader2 ? (
                <span>
                  <CircularProgress
                    fourColor
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </span>
              ) : (
                <p>
                  {" "}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </p>
              )}
            </Grid>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="p-2 rounded mt-2"
              bgcolor={"rgba(0, 0, 0, 0.32)"}
            >
              <Grid className="d-flex">
                <p>
                  {" "}
                  <IoMdSpeedometer className="text-light mx-2" size={30} />
                  Waiting for Confirmation
                </p>
              </Grid>

              {Loader3 ? (
                <span>
                  <CircularProgress
                    fourColor
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </span>
              ) : (
                <p>
                  {" "}
                  <IoMdCheckmarkCircleOutline
                    style={{ color: "#FFF" }}
                    size={20}
                  />
                </p>
              )}
            </Grid>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              className="mt-3 w-100 "
            >
              {hash ? (
                <a
                  href={REACT_APP_TRANSACTION_HASHLINK + hash}
                  target="blank"
                  style={{ color: "#fff" }}
                >
                  <GradiantButton
                    btnTextColor="#FFF"
                    text={"CHECK IN SCAN"}
                    borderColor={"#ffff"}
                    width="100%"
                    onClick={() => handleClose()}
                  />
                </a>
              ) : (
                <GradiantButton
                 
                  text={!isCompleted ? "CLOSE" : "CHECK IN SCAN"}
                  
                  borderColor={"#FFED8C"}
                  btnTextColor={"#FFED8C"}
                  btnColor={"#000000"}
                  disabled={!hash}

                  width="100%"
                  onClick={() => (!isCompleted ? handleClose() : "")}
                />
              )}
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

export default Walletaction;
